import React, { useState } from 'react';

import {
  colors,
  IOption,
  ApButtonSecondary,
  ApSimpleDropdown,
  ApIcon,
  ApTooltip,
} from '@alixpartners/ui-components';
import {
  Wrapper,
  WarningMessage,
  ControlsBar,
  RightAlign,
  TooltipHandle,
} from './DimensionControls.styles';
import isObject from 'lodash/isObject';

interface IProps {
  options?: IOption[];
  onDimensionChange?(dimension: IOption | IOption[]): void;
  onReuseAllocation(): void;
  dimension: IOption | string;
  message?: string;
}

export const DimensionControls: React.FC<IProps> = ({
  dimension,
  options,
  message,
  onDimensionChange,
  onReuseAllocation,
}) => {
  const [isMessageShown, setMessageShown] = useState(true);
  const hideMessage = () => setMessageShown(false);
  const isDropdown = options && isObject(dimension) && onDimensionChange;

  return (
    <Wrapper>
      <ControlsBar>
        {isDropdown ? (
          <>
            {isMessageShown ? (
              <ApIcon iconName="outline_error" iconColor={colors.amber} />
            ) : (
              <ApTooltip
                enterDelay={0}
                placement="top"
                message="Please make sure you pick a right dimension 
          in a menu above. Changing dimension 
          during allocation process causes loss of all 
          data entered before."
              >
                <TooltipHandle>
                  <ApIcon iconName="outline_error" iconColor={colors.grey8} />
                </TooltipHandle>
              </ApTooltip>
            )}
            <ApSimpleDropdown
              options={options!}
              onChange={onDimensionChange!}
              selected={dimension as IOption}
            />
          </>
        ) : (
          dimension
        )}

        <RightAlign>
          <ApButtonSecondary onClick={onReuseAllocation}>
            Reuse allocation
          </ApButtonSecondary>
        </RightAlign>
      </ControlsBar>
      {message && isMessageShown && (
        <WarningMessage>
          <span>{message}</span>
          <ApButtonSecondary onClick={hideMessage}>
            Ok, got it
          </ApButtonSecondary>
        </WarningMessage>
      )}
    </Wrapper>
  );
};
